import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class ContactService {

    static createPolicyContact(jobId, policyContactDetails, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gateway/contact'),
            'createPolicyContact',
            [jobId, policyContactDetails],
            additionalHeaders
        );
    }

    static removePolicyContact(jobId, contactId, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gateway/contact'),
            'removePolicyContact',
            [jobId, contactId],
            additionalHeaders
        );
    }

    static findStandardizedAddresses(anAddress, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayaddressstandardization'),
            'findStandardizedAddresses',
            [anAddress],
            additionalHeaders
        );
    }
}
